import * as React from 'react'

import { canvasProvider, cleverProvider, googleProvider, nycpsClassroomProvider } from './providerHelpers'

import { SMALL_ICON_BASE_SRC, } from '../../../Shared/index'

const lightBulbSrc = `${SMALL_ICON_BASE_SRC}/lightbulb.svg`
const questionMarkSrc = `${SMALL_ICON_BASE_SRC}/question-mark-green.svg`

interface ProviderNoteOfExplanationProps {
  allStudentsAreCanvas: boolean
  allStudentsAreClasslink: boolean
  allStudentsAreClever: boolean
  allStudentsAreGoogle: boolean
  allStudentsAreNycps: boolean
  classroom: any
  user: any
}

export const ProviderNoteOfExplanation = ({ allStudentsAreCanvas, allStudentsAreClasslink, allStudentsAreClever, allStudentsAreGoogle, allStudentsAreNycps, classroom, user, }: ProviderNoteOfExplanationProps) => {
  const allStudentsAreExternallyRostered = allStudentsAreGoogle || allStudentsAreClever || allStudentsAreCanvas || allStudentsAreClasslink || allStudentsAreNycps

  if (!classroom.visible) { return null }

  if (allStudentsAreExternallyRostered) {
    let copy: string, header: JSX.Element

    if (allStudentsAreGoogle) {
      header = <h4>This class is managed through <u>Google</u></h4>
      copy = user.classroom_provider === googleProvider
        ? "Your students’ account information is linked to your Google Classroom account. Go to your Google Classroom account to edit your students."
        : "Your students’ account information is on Google Classroom. To enable auto-syncing, you'll need to link your account to Google."
    } else if (allStudentsAreClever) {
      header = <h4>This class is managed through <u>Clever</u></h4>
      copy = user.classroom_provider === cleverProvider
        ? "Your students’ account information is auto-synced from your Clever account. You can modify your Quill class rosters from your Clever account."
        : "Your students’ account information is on Clever.  To enable auto-syncing, you'll need to link your account to Clever."
    } else if (allStudentsAreCanvas) {
      header = <h4>This class is managed through <u>Canvas</u></h4>
      copy = user.classroom_provider === canvasProvider
        ? "Your students’ account information is auto-synced from your Canvas Instance. Go to your Canvas Instance to edit your students."
        : "Your students’ account information is on Canvas. To enable auto-syncing, you'll need to link your account to Canvas."
    } else if (allStudentsAreClasslink) {
      if (classroom.classroomProviderActive === false) {
        header = <h4>This class is no longer managed through <u>ClassLink</u></h4>
        copy = "This class is no longer being synced with ClassLink"
      } else {
        header = <h4>This class is managed through <u>Classlink</u></h4>
        copy = "This class will be synced with ClassLink every 24 hours."
      }
    } else if (allStudentsAreNycps) {
      header = <h4>This class is managed through <u>{nycpsClassroomProvider}</u></h4>
      copy = "This class and its roster are synced from NYC Public Schools. Changes to the roster are made in your school's systems and appear here after the next sync."
    }
    return (
      <div className="provider-note-of-explanation">
        <img alt="" src={questionMarkSrc} />
        <div className="provider-note-of-explanation-text">
          {header}
          <p>{copy}</p>
        </div>
      </div>
    )
  }

  return null
}

export const DuplicateAccountProTip = () => {
  return (
    <div className="duplicate-account-pro-tip">
      <img alt="" src={lightBulbSrc} />
      <div className="duplicate-account-pro-tip-text">
        <h4>Pro Tip - How to manage duplicate accounts</h4>
        <p>If a student has multiple accounts that were created manually (with a Quill password), you can merge those accounts together. However, Google, Clever or Canvas accounts cannot be merged together. Instead, if a student has a duplicate Google, Clever or Canvas account, go to the “Actions” menu and select the “remove the student” option for the duplicate account.</p>
      </div>
    </div>
  )
}
